export default __webpack_public_path__ + "static/media/lord-shiva.421f8f3b.jpg";